<template>
  <a-modal
    :title="title"
    :width="450"
    :visible="visible"
    :closable="false"
    :maskClosable="closable">
    <template slot="footer">
      <a-button v-if="closable" @click="close">关闭</a-button>
      <a-button type="primary" @click="evalOk">确认</a-button>
    </template>

    <a-form>
      <a-form-item
        :labelCol="{span:4}"
        :wrapperCol="{span:25}"
        style="margin-bottom:10px">

        <a-select v-model="sectionIdSelected" placeholder="请选择标段进行服务评价" style="margin-left:10px;width: 80%">
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option
            v-for="d in bidSectionList"
            :key="d.id"
            :value="d.id"
            :title="d.bidSectionName">
            {{ d.bidSectionName }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

  import {getAction} from "@api/manage";

  export default {
    name: 'SectionIdsSelect',
    props:{
      closable:{
        type:Boolean,
        default:false,
        required:false
      },
    },
    watch: {
      bidProjectId(newVal, oldVal) {
        if (newVal) {
          this.loadSectionIdList().then(() => {
            if(!this.bidSectionList || this.bidSectionList.length<=0){
              // 如果标段数据不存在或者小于等于0，报错
              this.evalClear()
              this.$message.warning("获取标段信息异常!")
            } else if (this.bidSectionList.length == 1) {
              this.evalClear()
              this.$emit('showAssessmentForm', {bidProjectId: this.bidProjectId, sectionId: this.bidSectionList[0].id})
            } else {
              this.visible=true
            }
          });
        }
      }
    },
    data(){
      return {
        title: "标段选择",
        visible: false,
        bidSectionList:[],
        sectionIdSelected:undefined,
        bidProjectId: "",
      }
    },
    created(){
    },
    methods:{
      // 加载多标段信息
      loadSectionIdList(){
        return new Promise(resolve => {
          let url = "/ebid-ce/tmBidSection/queryByBidProjectId"
          let params = { "bidProjectId": this.bidProjectId }

          getAction(url, params).then(res=>{
            if(res.success){
              this.bidSectionList = res.result
            }
            resolve()
          })
        })
      },
      evalOk(){
        this.evalClear()
        this.$emit('showAssessmentForm', {bidProjectId: this.bidProjectId, sectionId: this.sectionIdSelected})
      },
      close(){
        this.evalClear()
      },
      // 展示本组件
      show(bid){
        this.bidProjectId = bid
        //如果组件传值username此处就不用loadroleList了
        this.loadSectionIdList().then(()=>{
          if(!this.bidSectionList || this.bidSectionList.length<=0){
            // 如果标段数据不存在或者小于等于0，报错
            this.evalClear()
            this.$message.warning("获取标段信息异常!")
          } else if (this.bidSectionList.length == 1) {
            this.evalClear()
            this.$emit('showAssessmentForm', {bidProjectId: this.bidProjectId, sectionId: this.bidSectionList[0].id})
          } else {
            this.visible=true
          }
        })
      },
      evalClear(){
        this.visible=false
      },

    }

  }
</script>
<style scoped>
</style>